/* eslint-disable no-throw-literal */
import axios from "axios";
import * as config from "../_config";
import { clearPersistedStore, makePersistable } from "mobx-persist-store";
import { M5User } from "./models/M5User";
import M5Param from "./models/M5Param";

export interface M5DocResponse<T> {
  expired?: boolean;
  docs?: T[];
  doc?: T;
  children: T[];
  parentId?: string;
  parents?: T[];
  total: number;
}
class M5APIs {
  static parsingParam = (param: M5Param) => {
    let where = "";
    let fetchChildrenJson = "";
    if (param.where != null || param.fetchChildrenJson != null) {
      let result = null;
      if (param.where != null) {
        where = JSON.stringify(param.where);
        result = {
          ...param,
          fetchUser: param.fetchUsers,
          where,
        };
      }
      if (param.fetchChildrenJson != null) {
        fetchChildrenJson = JSON.stringify(param.fetchChildrenJson);
        if (result) {
          result = {
            ...result,
            fetchUser: param.fetchUsers,
            fetchChildrenJson,
          };
        } else {
          result = {
            ...param,
            fetchUser: param.fetchUsers,
            fetchChildrenJson,
          };
        }
      }

      return result;
    } else {
      return {
        ...param,
        fetchUser: param.fetchUsers,
      };
    }
  };

  static async login(username: string, password: string) {
    const url = `${config.M5_SERVER}/v2/login`;
    console.log(url, config.M5_APIKEY);
    console.log(username, password);
    try {
      const response = await axios.post(
        url,
        {
          username,
          password,
        },
        {
          headers: {
            "X-M5-API-KEY": config.M5_APIKEY,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response);

      if (!response.data) {
        throw { code: 0 };
      } else if (response.data.header.code !== 200) {
        throw response.data.header;
      } else {
        console.log(response.data);
        return response.data;
      }
    } catch (error) {
      console.log("##", error);
      throw error;
    }
  }

  static async loginByGraphId(graphid: string, password: string) {
    const url = `${config.M5_SERVER}/v2/loginByGraphId`;
    console.log(url, config.M5_APIKEY);
    console.log(graphid, password);
    try {
      const response = await axios.post(
        url,
        {
          graphid,
          password,
        },
        {
          headers: {
            "X-M5-API-KEY": config.M5_APIKEY,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response);

      if (!response.data) {
        throw { code: 0 };
      } else if (response.data.header.code !== 200) {
        throw response.data.header;
      } else {
        console.log(response.data);
        return response.data;
      }
    } catch (error) {
      console.log("##", error);
      throw error;
    }
  }

  static async loginByEmail(email: string, password: string) {
    const url = `${config.M5_SERVER}/v2/loginByEmail`;
    console.log(url, config.M5_APIKEY);
    console.log(email, password);
    try {
      const response = await axios.post(
        url,
        {
          email,
          password,
        },
        {
          headers: {
            "X-M5-API-KEY": config.M5_APIKEY,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response);

      if (!response.data) {
        throw { code: 0 };
      } else if (response.data.header.code !== 200) {
        throw response.data.header;
      } else {
        console.log(response.data);
        return response.data;
      }
    } catch (error) {
      console.log("##", error);
      throw error;
    }
  }

  /**
   * 시용자 정보 변경
   * @param user
   * @param edit
   * @returns
   */
  static async updateUser(user: M5User) {
    const URL = `${config.M5_SERVER}/v2/users/${user.id}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;
    return axios
      .put(URL, user, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((response) => console.log(response));
  }

  /**
   * 시용자 정보 변경
   * @param user
   * @param edit
   * @returns
   */
  static async updateMyInfo(user: M5User) {
    const URL = `${config.M5_SERVER}/v2/my`;
    const auth = `Bearer ${M5APIs.getBearer()}`;
    return axios
      .put(URL, user, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response);
  }

  static async convertId(userId: string, itemId:string) {
    const URL = `https://api-pas.jeisys.com/sync/apponly/convertId?userId=${userId}&itemId=${itemId}`;
    return axios
      .get(URL)
      .then((response) => {
        return response.data;
      });
  }

  static async fetchMyInfo() {
    const URL = `${config.M5_SERVER}/v2/my`;
    const auth = `Bearer ${M5APIs.getBearer()}`;
    return axios
      .get(URL, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response.data.my;
      });
  }

  static async checkAccessToken() {
    const url = `${config.M5_SERVER}/v2/accessToken`;
    console.log(url, config.M5_APIKEY);
    try {
      const response = await axios.post(
        url,
        {
          accessToken: localStorage.getItem("accessToken"),
          refresh: false,
        },
        {
          headers: {
            "X-M5-API-KEY": config.M5_APIKEY,
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response);
      if (!response.data) {
        throw { code: 0 };
      } else if (response.data.header.code !== 200) {
        throw response.data.header;
      } else {
        console.log(response.data);
        return response.data;
      }
    } catch (error) {
      console.log("##", error);
      throw error;
    }
  }

  static getBearer() {
    const PAS = localStorage.getItem("PAS");
    const pasObject = JSON.parse(PAS as string);
    return pasObject._accessToken;
  }
  static async fetchServerTime() {
    const url = `${config.M5_SERVER}/v2/ping`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  static async createBuckets(buckets: Array<any>) {
    const url = `${config.M5_SERVER}/v2/buckets`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .post(url, buckets, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  static async fetchBuckets(of: string, types: string, params: any) {
    const url = `${config.M5_SERVER}/v2/buckets`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    params.types = types;
    if (params.types === undefined) {
      params.types = "";
    }
    params["for"] = of;

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: params,
      })
      .then((res) => {
        return res.data;
      });
  }

  static async createDocs(
    bucketId: string,
    docs: Array<any>,
    checkCodeMode: string
  ) {
    const url = `${config.M5_SERVER}/v2/buckets/${bucketId}/docs`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    console.log(docs);

    return axios
      .post(url, docs, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: { checkCodeMode: checkCodeMode },
      })
      .then((res) => {
        return res.data;
      });
  }

  static async findAllDocs<T>(types: string, params: M5Param) {
    const url = `${config.M5_SERVER}/v2/docs`;
    const auth = `Bearer ${M5APIs.getBearer()}`;
    if (types === undefined) {
      params.types = "";
    } else {
      params.types = types;
    }

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: this.parsingParam(params),
      })
      .then((res) => {
        return res.data as M5DocResponse<T>;
      });
  }

  static async fetchDocs<T>(
    bucketId: string | null,
    types: string,
    params: any
  ) {
    // let url = `${config.M5_SERVER}/v2/buckets/${bucketId}/docs`;

    // if (bucketId == null) {
    //   url = `${config.M5_SERVER}/v2/docs`;
    // }
    const url = `${config.M5_SERVER}/v2/buckets/${bucketId}/docs`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    if (types === undefined) {
      params.types = "";
    } else {
      params.types = types;
    }

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: this.parsingParam(params),
      })
      .then((res) => {
        return res.data as M5DocResponse<T>;
      });
  }
  static async fetchDocById<T>(
    docId: string | null,
    bucketId: string | null,
    types: string,
    params: any
  ) {
    const url = `${config.M5_SERVER}/v2/docs/${docId}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    if (types === undefined) {
      params.types = "";
    } else {
      params.types = types;
    }

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: this.parsingParam(params),
      })
      .then((res) => {
        return res.data as M5DocResponse<T>;
      });
  }

  static async updateDocs(
    bucketId: string,
    docs: Array<any>,
    checkCodeMode: string
  ) {
    const url = `${config.M5_SERVER}/v2/buckets/${bucketId}/docs`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .put(url, docs, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: { checkCodeMode: checkCodeMode },
      })
      .then((res) => {
        console.log(res);
        return res.data;
      });
  }

  static async updateDocsContainer(docs: Array<any>, checkCodeMode: string) {
    const url = `${config.M5_SERVER}/v2/docs`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .put(url, docs, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: { checkCodeMode: checkCodeMode },
      })
      .then((res) => {
        console.log(res);
        return res.data;
      });
  }

  static async deleteDoc(bucketId: string, docId: string) {
    const url = `${config.M5_SERVER}/v2/buckets/${bucketId}/docs/${docId}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .delete(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  static async fetchCategories(bucketId: string, types: string) {
    const url = `${config.M5_SERVER}/v2/buckets/${bucketId}/categories?types=${types}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;
    console.log(url);

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }
  static async createCategories(bucketId: string, docs: any) {
    const url = `${config.M5_SERVER}/v2/buckets/${bucketId}/categories`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .post(url, docs, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }
  static async updateCategories(docs: any) {
    const url = `${config.M5_SERVER}/v2/categories/`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .put(url, docs, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  static async removeCategories(categoryId: string) {
    const url = `${config.M5_SERVER}/v2/categories/${categoryId}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .delete(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  static async fetchCollectionDocs(collectionId: string, params: any) {
    const url = `${config.M5_SERVER}/v2/collections/${collectionId}/docs`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: params,
      })
      .then((res) => {
        return res.data;
      });
  }

  static async addCollectionsDocId(collectionId: string, idList: any) {
    const url = `${config.M5_SERVER}/v2/collections/${collectionId}/docs?idList=${idList}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .put(url, idList, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  static async removeCollectionsDocId(collectionId: string, idList: any) {
    const url = `${config.M5_SERVER}/v2/collections/${collectionId}/docs?idList=${idList}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .delete(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  static async deleteFile(docId: string, fileId: string) {
    const url = `${config.M5_SERVER}/v2/docs/${docId}/files/${fileId}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .delete(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  /**
   * Fetch Users of a UserGroup
   */
  static async fetchUsers(params: any) {
    const url = `${config.M5_SERVER}/v2/users`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    console.log(url);
    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: params,
      })
      .then((res) => {
        return res.data;
      });
  }

  static async fetchUserById(params: any, id: string) {
    const url = `${config.M5_SERVER}/v2/users/${id}`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: params,
      })
      .then((res) => {
        return res.data;
      });
  }

  /**
   * VOUCHERS
   */
  static async fetchVouchers(bucketId: string, types: string, params: any) {
    const url = `${config.M5_SERVER}/v2/buckets/${bucketId}/vouchers`;
    const auth = `Bearer ${M5APIs.getBearer()}`;

    if (types === undefined) {
      params.types = "";
    } else {
      params.types = types;
    }

    return axios
      .get(url, {
        headers: {
          "X-M5-API-KEY": config.M5_APIKEY,
          Authorization: auth,
          "Content-Type": "application/json",
        },
        params: params,
      })
      .then((res) => {
        return res.data;
      });
  }
}

export default M5APIs;
